<template>
  <validation-provider :name="texto" :rules="{ required: requerida }" v-slot="validationContext">
    <b-form-group label-cols-md="4" :label="texto + ':'" :label-for="realId">
      <b-form-file :id="realId" v-model="respuesta" :placeholder="placeholder" drop-placeholder="Arrastra una imagen aquí" accept=".png,.gif,.jpg,.jpeg" :state="getValidationState(validationContext)"></b-form-file>
      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      <b-form-text v-if="ayuda">{{ ayuda }}</b-form-text>
    </b-form-group>
  </validation-provider>
</template>

<script lang="ts">
import axios from 'axios'
import _ from 'lodash'
import { nanoid } from 'nanoid'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { url } from '../../services/url_service'

@Component
export default class TipoDocumento extends Vue {
  @Prop() id: string
  @Prop() texto: string
  @Prop({ default: '' }) ayuda: string
  @Prop({ default: true }) requerida: Boolean
  @Prop() placeholder: string
  @Prop() value: any

  get realId(): string {
    return this.id || 'imagen-' + nanoid()
  }

  public respuesta: File = null
  public filename: string = null
  public uploaded: boolean = false

  getValidationState({ validated, dirty = null, valid = null, passed = null }) {
    return validated || valid ? valid : null
  }

  @Watch('respuesta')
  async onRespuestaChange(value?: File) {
    let formData = new FormData()
    formData.append('UPLOAD', value)
    try {
      let response = await axios.post(url.create('/external/upload'), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      this.uploaded = true
      this.$emit('input', _.join(response.data.files, ','))
    } catch (ex) {
      this.uploaded = false
      this.$bvToast.toast(
        'Error al subir la imagen, intente nuevamente o contactenos',
        {
          title: 'Documento no enviado',
          variant: 'danger',
          autoHideDelay: 5000,
        }
      )
    }
  }

  @Watch('value')
  onValueChange(value) {
    this.filename = value
  }

  // async subirDocumento(archivo) {
  //   
  // }

  created() {
    this.filename = this.value || null
  }
}
</script>